module.exports = __webpack_public_path__ + "static/img/5.8139e37.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/brand/5.png
// module id = 2mQj
// module chunks = 45